export class UsercentricsService {
    private cookieConsentCache: {
        data: Record<string, boolean | undefined>,
        ready: boolean,
    } = {
        data: {},
        ready: false
    };

    public initCookieConsentCache(): void {
        const cache: Record<string, boolean | undefined> = {};

        window.addEventListener("UC_CONSENT", (event) => {
            const eventData = (event as CustomEvent).detail;
            const services = eventData.services || {};

            for (const serviceId in services) {
                const service = services[serviceId];
                if (service && service.name && typeof service.consent?.given === 'boolean') {
                    cache[service.name] = service.consent.given;
                }
            }

            this.cookieConsentCache.ready = true;
            this.cookieConsentCache.data = cache;
        });
    }

    public getCookieConsentData(serviceName: string): boolean | null {
        let serviceConsent = this.cookieConsentCache.data[serviceName] ?? null;

        if (serviceConsent === null && this.cookieConsentCache.ready) {
            console.error('Service name not found in cookie consent data:', serviceName);
        }

        if (serviceConsent === null && !this.cookieConsentCache.ready) {
            console.error('Cookie consent data is not initialized.');
        }

        return serviceConsent;
    }

    public isInitialized(): boolean {
        return this.cookieConsentCache.ready;
    }
}

(<any>window).skyComponents = (<any>window).skyComponents || {};
(<any>window).skyComponents.usercentricsService = new UsercentricsService();
(<any>window).skyComponents.usercentricsService.initCookieConsentCache();
